import { InMemoryCacheConfig, defaultDataIdFromObject } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';

export const cacheConfig: InMemoryCacheConfig = {
  dataIdFromObject(object) {
    if ('id' in object && typeof object.id === 'string') {
      try {
        const decoded = atob(object.id);
        if (
          decoded.includes(':') &&
          decoded.split(':').shift() === object.__typename
        ) {
          return decoded;
        }
      } catch (error) {
        //
      }
    }

    return defaultDataIdFromObject(object);
  },
  typePolicies: {
    ShiftType: {
      keyFields: ['id', 'shiftType'],
    },
    Query: {
      fields: {
        availableShifts: relayStylePagination(),
        myUpcomingShifts: relayStylePagination(),
        myPastShifts: relayStylePagination(),
        myBids: relayStylePagination(),
      },
    },
  },
};
